<template>
  <button class="services__button" @click="togglePopup">{{ title }}</button>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Quiero TRIOTECA free plus',
    },
  },
  computed: {},
  methods: {
    togglePopup() {
      this.$emit('toggle-popup');
    },
  },
};
</script>
